import { Button, DrawerRight, Loading, TextField, Title } from 'src/components';
import { Grid } from '@material-ui/core';
import { type ISection } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import { userTypes } from '../../../../../../helpers/constants';
import sectionActions from 'src/store/Sections/actions';

import Questions from './Questions';
import Videos from './Videos';
import useStyles from './SectionEdition-styles';

function SectionEdition() {
	const { sectionId }: any = useParams();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const classes = useStyles();
	const user = useSelector((state: RootState) => state.auth.data);
	const course = useSelector((state: RootState) => state.courses.course);
	const { isLoadingOne, section } = useSelector(
		(state: RootState) => state.sections,
	);

	const getSection = (id: number) => dispatch(sectionActions.getOne(id));
	const updateSection = (section: ISection) =>
		dispatch(sectionActions.update(section));
	const clearSection = () => dispatch(sectionActions.setOne({}));
	const [drawerOpen, setDrawerOpen] = useState(false);

	useEffect(() => {
		getSection(sectionId);

		return () => {
			clearSection();
		};
	}, [sectionId]);

	function handleDrawerOpen() {
		setDrawerOpen(!drawerOpen);
	}

	const { handleChange, handleReset, handleSubmit, values } = useFormik({
		enableReinitialize: true,
		initialValues: section,
		onSubmit: (values) => {
			updateSection(values);
			handleDrawerOpen();
			handleReset({});
		},
	});

	return (
		<Loading isLoading={isLoadingOne}>
			<DrawerRight
				onClose={handleDrawerOpen}
				open={drawerOpen}
				title={'Editar sección'}
			>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							label={'Nombre'}
							multiline
							name={'name'}
							onChange={handleChange}
							value={values.name}
						/>
					</Grid>

					<Grid item xs={12}>
						<Button
							actionType={'save'}
							fullWidth
							onClick={() => {
								handleSubmit();
							}}
						>
							Guardar Cambios
						</Button>
					</Grid>
				</Grid>
			</DrawerRight>

			<Grid item xs={6}>
				<Title
					breadcrumbs={[
						{ label: 'Cursos', link: '/app/courses' },
						{
							label: course.name,
							link: `/app/courses/edit/${course.id}`,
						},
						{ label: section.name },
					]}
					title={section.name}
				/>
			</Grid>

			<Grid className={classes.buttonContainer} item xs={6}>
				{user.type === userTypes.ADMIN && (
					<Button
						actionType={'edit'}
						backgroundColor={'secondary'}
						hideLabelOnMobile
						onClick={handleDrawerOpen}
					>
						Editar
					</Button>
				)}
			</Grid>

			<Videos />

			<Questions />
		</Loading>
	);
}

export default SectionEdition;
